import React from "react";
import { defaultState } from "tsi-common-react/src/apps/reviews/defaults";
import { updateSorting } from "tsi-common-react/src/apps/reviews/reducers";
import { ReviewSortOption } from "tsi-common-react/src/models/reviews";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/store/reducers";
import { CAPTION_LIGHT_CLASS_NAME } from "tsi-common-react/src/utils/typography";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { UnstyledSelect } from "../../../components/UnstyledSelect";

export const SortingSelector = () => {
    const dispatch = useAppDispatch();

    const sortOptions = useAppSelector(
        (state) => (state.reviews || defaultState).data.sortOptions,
    );
    const selectedSortOption = useAppSelector(
        (state) => (state.reviews || defaultState).ui.selectedSortOption,
    );

    return (
        <div className="reviews-region-sort">
            {/* TODO(i18n): Use t tagged template: {t`Sort:`} */}
            <div
                className={concatClassNames([
                    "review-menu-title",
                    CAPTION_LIGHT_CLASS_NAME,
                ])}
            >
                Sort:
            </div>
            <UnstyledSelect
                noBorder
                className="select select--large-down-arrow review-select"
                value={selectedSortOption}
                onChange={(event) => {
                    dispatch(
                        updateSorting(
                            event.currentTarget.value as ReviewSortOption,
                        ),
                    );
                }}
            >
                {/* TODO(i18n): Sort option labels in defaults.ts (lines 10, 14, 18, 22) need translation. Consider translating labels here in the component instead: {props.sortOptions.map((opt) => (<option key={opt.value} value={opt.value}>{t`${opt.label}`}</option>))} or create a translation mapping function */}
                {sortOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </UnstyledSelect>
        </div>
    );
};
